import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';

interface Params {
    storeUrl: string;
}

const ForceUpdateModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { storeUrl } = params;
    return (
        <Modal onOutsideClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }}>
            <ModalContainer>
                <Column fullWidth spacing={24} align='center'>
                    <Text size='xl'>앱 업데이트가 필요합니다.</Text>
                    <Button onClick={() => openExternalLink(storeUrl)}>
                        스토어로 이동
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default ForceUpdateModal;
